module.exports = __webpack_public_path__ + "img/client_service_manager.5c27627b.svg";